// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PostPrompt-cls1__d4496da3731b6f08113f{/*!*/}.PostPrompt-cls2___318495e7a81cf9ea7f4{flex-shrink:0;--size: 48px}@media(min-width: 768px){.PostPrompt-cls2___318495e7a81cf9ea7f4{--size: 60px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PostPrompt-cls1__d4496da3731b6f08113f",
	"cls2": "PostPrompt-cls2___318495e7a81cf9ea7f4 PostPrompt-cls1__d4496da3731b6f08113f"
};
export default ___CSS_LOADER_EXPORT___;
